/**
 * Execute a function in a way that if it throws it will send back a default
 * @param {Object} options - Object of options, function, args, and defaultOnFail
 * @returns
 */
export const tryCatchFuncWrapper = (
  options = { func: () => {}, args: [], defaultOnFail: '' }
) => {
  let defaultOnFail
  try {
    defaultOnFail = options.defaultOnFail
    const { func, args } = options
    return func(...args)
  } catch (error) {
    return defaultOnFail
  }
}
